<template>
  <div class="drivers">
    <div class="driver-list">
      <div @click="goBack" class="backDiv" style="margin-left: 5px; margin-right: auto;">
        <i class="pi pi-arrow-left"></i>
        <span> Coverage</span>
      </div>
      <div class="driver-item" v-for="driver in paginatedDrivers" :key="driver.driverLicense">
        <p>{{ driver.driver_name }}</p>
        <div class="driver-info">
          <p>State: {{ driver.state }}</p>
          <p>License: {{ driver.driver_licence }}</p>
          <p>Date of Birth: {{ driver.birth_date }}</p>
          <p>Years of Experience: {{ driver.year_experience }}</p>
        </div>
      </div>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination">
      <button :disabled="currentPage === 1" @click="previousPage">Previous</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button :disabled="currentPage === totalPages" @click="nextPage">Next</button>
    </div>

    <div class="actions">
      <button @click="requestChanges" class="btn btn-request request-changes"><i class="pi pi-pencil"></i> Request Changes</button>
      <button @click="infoIsCorrect" class="btn btn-correct info-correct"><i class="pi pi-check" style="font-weight: bold;"></i> Info is Correct</button>
    </div>
    
    <div class="note">
      <p>Please note that this does not initiate any changes to your current active policy.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriversInfo',
  data() {
    return {
      drivers: [],
      currentPage: 1,
      itemsPerPage: 6
    };
  },
  computed: {
    paginatedDrivers() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.drivers.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.drivers.length / this.itemsPerPage);
    }
  },
  mounted() {
    // Retrieve data from localStorage
    const storedData = localStorage.getItem('deruloData');
    if (storedData) {
      const data = JSON.parse(storedData);
      // Access the drivers array within the nested structure
      this.drivers = data.drivers || [];
    } else {
      console.error('No data found in localStorage');
    }
  },
  methods: {
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    requestChanges() {
      this.$router.push({
      path: '/driverschanges'
    });
    },
    infoIsCorrect() {
      localStorage.setItem('driver_changes', 'No Changes Requested');
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      sessionStorage.setItem('scrollToTop', 'true');
      sessionStorage.setItem('previousScrollPosition', scrollPosition);
      this.$router.push({
      path: '/equipmentinfo'
    });
    },
    goBack() {
      // Store the current scroll position
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Set a flag in sessionStorage before navigation
      sessionStorage.setItem('scrollToTop', 'true');
      sessionStorage.setItem('previousScrollPosition', scrollPosition);

      // Navigate back
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
/* Your existing styles */
i {
  margin-right: 5px;
}

.drivers {
  text-align: center;
  padding: 10px;
}

.driver-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 20px;
}

.driver-item {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 0px 20px;
  width: 95%;
  margin: 10px 0;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.driver-info {
  margin: 20px 0px;
}

.driver-info p {
  margin: 5px 0px;
}

.actions {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.pagination button {
  margin: 0 10px;
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  background-color: #004d40;
  color: white;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.note {
  font-size: 0.8em;
  color: #888;
}

@media (min-width: 1000px) {
  .drivers {
    width: 550px !important;
  }
}
</style>
